"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvailableNotificationPreferences = exports.NotificationPreferenceSectionData = exports.NotificationPreferenceItemData = exports.NotificationSubCategory = exports.NotificationCategory = exports.NotificationPreferenceOptionsEnum = exports.SurveyReference = void 0;
var SurveyReference;
(function (SurveyReference) {
    SurveyReference["motUsefulnessSurveyEngaged"] = "mot_usefulness_survey_engaged";
    SurveyReference["motUsefulnessSurveyNotEngaged"] = "mot_usefulness_survey_not_engaged";
})(SurveyReference || (exports.SurveyReference = SurveyReference = {}));
var NotificationPreferenceOptionsEnum;
(function (NotificationPreferenceOptionsEnum) {
    NotificationPreferenceOptionsEnum["web"] = "web";
    NotificationPreferenceOptionsEnum["instantEmail"] = "instantEmail";
    NotificationPreferenceOptionsEnum["digestEmail"] = "digestEmail";
})(NotificationPreferenceOptionsEnum || (exports.NotificationPreferenceOptionsEnum = NotificationPreferenceOptionsEnum = {}));
var NotificationCategory;
(function (NotificationCategory) {
    NotificationCategory["preTransport"] = "preTransport";
    NotificationCategory["mainCarriage"] = "mainCarriage";
    NotificationCategory["onCarriage"] = "onCarriage";
    NotificationCategory["other"] = "other";
})(NotificationCategory || (exports.NotificationCategory = NotificationCategory = {}));
var NotificationSubCategory;
(function (NotificationSubCategory) {
    NotificationSubCategory["crd"] = "crd";
    NotificationSubCategory["rolledCargo"] = "rolledCargo";
    NotificationSubCategory["booking"] = "booking";
    NotificationSubCategory["customs"] = "customs";
    NotificationSubCategory["demdet"] = "demdet";
    NotificationSubCategory["miscellaneous"] = "miscellaneous";
    NotificationSubCategory["shipmentUpdates"] = "shipmentUpdates";
})(NotificationSubCategory || (exports.NotificationSubCategory = NotificationSubCategory = {}));
class NotificationPreferenceItemData {
}
exports.NotificationPreferenceItemData = NotificationPreferenceItemData;
class NotificationPreferenceSectionData {
}
exports.NotificationPreferenceSectionData = NotificationPreferenceSectionData;
class AvailableNotificationPreferences {
}
exports.AvailableNotificationPreferences = AvailableNotificationPreferences;
//# sourceMappingURL=availableNotificationPreferences.js.map